export enum RichLogTextStyle {
  Bold = "Bold",
  Italic = "Italic",
  Red = "Red",
}
